declare global {
  interface Document {
    invalidateMiniCartData: (data: Record<string, unknown>) => void;
  }
}

// comment carried over from ODUI
// TODO - invalidateMiniCartData() is currently broken in staging due to a bug in Bookends.
// See discussion: https://vistaprint.slack.com/archives/CHWCBMDU2/p1677256275443279
export const invalidateMiniCartData = () => {
  if (!(typeof window === `undefined` || typeof document === `undefined`)) {
    document.invalidateMiniCartData({});
  }
};
